import React from 'react';
import {
  Breadcrumb,
  Card,
  Row,
  Col,
  Statistic,
  Spin,
  Button,
  Divider,
  Typography,
  Tag,
  Modal,
  Form,
  Input,
  Select,
  Tooltip,
  Empty,
  Badge,
  message,
  Radio,
  Progress,
  Drawer,
} from 'antd';
import {
  HomeOutlined,
  FileAddOutlined,
  CheckSquareOutlined,
  EditOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  DollarOutlined,
  ReloadOutlined,
  BankOutlined,
  EnvironmentOutlined,
  PlusOutlined,
  NotificationOutlined,
  CodeOutlined,
  DesktopOutlined,
  InfoCircleOutlined,
  DeleteOutlined,
  UserOutlined,
  CalendarOutlined,
  CloseOutlined,
  FilterOutlined,
  ApartmentOutlined,
  TeamOutlined,
  SyncOutlined,
  ClockCircleOutlined,
  CarOutlined,
  RiseOutlined,
  ThunderboltOutlined,
  TrophyOutlined,
  FieldTimeOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
} from '../store/actions';

import Config from '../Config';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import Chart from 'chart.js';
import { Line, Bar, HorizontalBar } from 'react-chartjs-2';
import RealtimePenerimaan from './RealtimePenerimaan';
import DashboardDetailModal from '../components/DashboardDetailModal';
import { chartOptions, parseOptions } from '../vars/chart.jsx';

const { Text } = Typography;

const configClass = {
  title: 'DASHBOARD',
  apiUrl: {
    dashboard: 'transaksi/api/dashboard/',
    breakdownBulan: 'transaksi/api/dashboard/breakdown-bulan/',
    breakdownHari: 'transaksi/api/dashboard/breakdown-hari/',
    pengumuman: 'master/api/pengumuman/',
    kabupaten: 'master/api/kabupaten/',
    upt: 'pegawai/api/upt/',
  },
};

const TIPE_CONFIG = {
  backend: { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff', icon: <CodeOutlined />, label: 'Backend' },
  frontend: { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', icon: <DesktopOutlined />, label: 'Frontend' },
  umum: { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f', icon: <InfoCircleOutlined />, label: 'Umum' },
};

const config = new Config();

const WARNA = {
  biru: '#1890ff',
  oranye: '#fa8c16',
  hijau: '#52c41a',
  ungu: '#722ed1',
};

function buildGrafikHarian(dataTahunIni, dataTahunLalu, tahun, tahunLalu) {
  const labels = dataTahunIni.map(d => d.tanggal);
  return {
    labels,
    datasets: [
      {
        label: `Pembayaran ${tahun}`,
        data: dataTahunIni.map(d => d.pembayaran),
        borderColor: WARNA.hijau,
        backgroundColor: 'rgba(82,196,26,0.08)',
        pointRadius: 3,
        borderWidth: 2,
        fill: true,
      },
      {
        label: `Pembayaran ${tahunLalu}`,
        data: dataTahunLalu.map(d => d.pembayaran),
        borderColor: WARNA.biru,
        backgroundColor: 'rgba(24,144,255,0.06)',
        borderDash: [5, 4],
        pointRadius: 2,
        borderWidth: 1.5,
        fill: false,
      },
    ],
  };
}

function buildGrafikBulanan(data, tahun, tahunLalu) {
  const labels = data.map(d => d.bulan);
  const pembayaran = data.map(d => d.pembayaran);
  const pembayaranLalu = data.map(d => d.pembayaran_lalu);

  let cumul = 0;
  const kumulatif = pembayaran.map(v => (cumul += (v || 0)));

  return {
    labels,
    datasets: [
      {
        type: 'bar',
        label: `Pembayaran ${tahun}`,
        data: pembayaran,
        backgroundColor: 'rgba(82,196,26,0.75)',
        borderColor: '#52c41a',
        borderWidth: 1,
        yAxisID: 'y-kendaraan',
      },
      {
        type: 'bar',
        label: `Pembayaran ${tahunLalu}`,
        data: pembayaranLalu,
        backgroundColor: 'rgba(24,144,255,0.45)',
        borderColor: '#1890ff',
        borderWidth: 1,
        yAxisID: 'y-kendaraan',
      },
      {
        type: 'line',
        label: `Kumulatif ${tahun}`,
        data: kumulatif,
        borderColor: '#fa8c16',
        backgroundColor: 'rgba(250,140,22,0.06)',
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: '#fa8c16',
        borderWidth: 2.5,
        fill: false,
        yAxisID: 'y-kumulatif',
      },
    ],
  };
}

const emptyHarian = buildGrafikHarian([], [], '', '');
const emptyBulanan = buildGrafikBulanan([]);

const tickFormatter = value => value >= 1000 ? value.toLocaleString('id-ID') : value;

const tooltipCallbacks = {
  label: (item, data) => {
    const label = data.datasets[item.datasetIndex].label || '';
    const val = item.yLabel;
    return `${label}: ${Number(val).toLocaleString('id-ID')}`;
  },
};

const lineOptions = {
  responsive: true,
  maintainAspectRatio: true,
  legend: { display: true, position: 'top' },
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        precision: 0,
        callback: tickFormatter,
      },
      scaleLabel: { display: true, labelString: 'Jumlah Kendaraan' },
    }],
    xAxes: [{ ticks: { autoSkip: true, maxTicksLimit: 10 } }],
  },
  tooltips: {
    mode: 'index',
    intersect: false,
    callbacks: {
      label: (item, data) => {
        const label = data.datasets[item.datasetIndex].label || '';
        const val = item.yLabel;
        return `${label}: ${Number(val).toLocaleString('id-ID')} kendaraan`;
      },
    },
  },
};

const barOptions = {
  responsive: true,
  maintainAspectRatio: true,
  legend: { display: true, position: 'top' },
  scales: {
    yAxes: [{ ticks: { beginAtZero: true, precision: 0, callback: tickFormatter } }],
  },
  tooltips: { mode: 'index', intersect: false, callbacks: tooltipCallbacks },
};

const comboOptions = {
  responsive: true,
  maintainAspectRatio: true,
  legend: { display: true, position: 'top' },
  scales: {
    yAxes: [
      {
        id: 'y-kendaraan',
        type: 'linear',
        position: 'left',
        ticks: { beginAtZero: true, precision: 0, callback: tickFormatter },
        scaleLabel: { display: true, labelString: 'Jumlah Kendaraan', fontSize: 11 },
        gridLines: { color: 'rgba(0,0,0,0.05)' },
      },
      {
        id: 'y-kumulatif',
        type: 'linear',
        position: 'right',
        ticks: { beginAtZero: true, precision: 0, callback: tickFormatter },
        scaleLabel: { display: true, labelString: 'Kumulatif', fontSize: 11 },
        gridLines: { drawOnChartArea: false },
      },
    ],
    xAxes: [{ ticks: { autoSkip: false } }],
  },
  tooltips: {
    mode: 'index',
    intersect: false,
    callbacks: {
      label: (item, data) => {
        const ds = data.datasets[item.datasetIndex];
        const val = Number(item.yLabel).toLocaleString('id-ID');
        return ds.type === 'line'
          ? `${ds.label}: ${val} (kumulatif)`
          : `${ds.label}: ${val} kendaraan`;
      },
    },
  },
};

function buildGrafikPerUpt(data) {
  const palette = [
    '#1890ff', '#52c41a', '#fa8c16', '#722ed1', '#13c2c2',
    '#eb2f96', '#faad14', '#a0d911', '#2f54eb', '#f5222d',
    '#08979c', '#7cb305', '#d46b08', '#531dab', '#006d75',
  ];
  return {
    labels: data.map(d => d.upt),
    datasets: [{
      label: 'Pembayaran Bulan Ini',
      data: data.map(d => d.pembayaran),
      backgroundColor: data.map((_, i) => palette[i % palette.length] + 'cc'),
      borderColor: data.map((_, i) => palette[i % palette.length]),
      borderWidth: 1,
      borderRadius: 4,
    }],
  };
}

const perUptOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: { display: false },
  scales: {
    xAxes: [{ ticks: { beginAtZero: true, precision: 0, callback: tickFormatter } }],
    yAxes: [{ ticks: { fontSize: 11 } }],
  },
  tooltips: {
    callbacks: {
      label: item => `Pembayaran: ${Number(item.xLabel).toLocaleString('id-ID')}`,
    },
  },
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this._breakdownRefreshTimer = null;
    this.state = {
      loading: false,
      isSuperuser: false,
      uptNama: '',
      tahun: new Date().getFullYear(),
      tahunLalu: new Date().getFullYear() - 1,
      hariIni: { pendaftaran: 0, penetapan: 0, pembayaran: 0, total_pendapatan: 0 },
      bulanIni: { pendaftaran: 0, penetapan: 0, pembayaran: 0, total_pendapatan: 0 },
      grafikHarian: emptyHarian,
      grafikBulanan: emptyBulanan,
      // Pengumuman
      pengumuman: [],
      loadingPengumuman: false,
      isModalPengumuman: false,
      submitPengumuman: false,
      formPengumuman: { judul: '', isi: '', tipe: 'umum', versi: '' },
      editPengumuman: null,
      isEditModalPengumuman: false,
      loadingTogglePengumuman: null,
      levelUser: 3,
      isPanelOpen: false,
      // Modal detail kartu "Hari Ini" (pendaftaran/penetapan/pembayaran)
      detailModalStatus: null,
      // Indikator pemutihan
      pemutihan: null,
      // Rincian pendapatan
      breakdownMode: 'hari',           // 'bulan' | 'hari'
      breakdownBulan: null,
      breakdownBulanSelected: new Date().getMonth() + 1,
      breakdownTahunSelected: new Date().getFullYear(),
      loadingBreakdown: false,
      breakdownHari: null,
      loadingBreakdownHari: false,
      // Filter (cakupan 1 & 2)
      cakupan_user: 0,
      kabupatenParam: null,
      uptParam: null,
      listKabupaten: [],
      listUpt: [],
      loadingFilter: false,
      grafikPerUpt: { labels: [], datasets: [] },
      showPerUpt: false,
      // Fitur tambahan
      distribusiLayanan: [],
      kendaraanJatuhTempo: { h7: 0, h14: 0, h30: 0 },
      grafikJam: [],
      distribusiJenisKendaraan: [],
      rataRataWaktu: { daftar_ke_penetapan: 0, penetapan_ke_pembayaran: 0, total: 0, jumlah_sampel: 0 },
      rankingUpt: [],
      targetRealisasi: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
    if (window.Chart) {
      parseOptions(Chart, chartOptions());
    }
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
    if (this._breakdownRefreshTimer) clearTimeout(this._breakdownRefreshTimer);
  }

  _onNewTransactionHari = (item = {}) => {
    // Update badge realtime berdasarkan tipe event
    const tipe = item.type;
    if (tipe === 'pendaftaran' || tipe === 'penetapan' || tipe === 'pembayaran') {
      this.setState(prev => {
        const h = { ...prev.hariIni };
        if (tipe === 'pendaftaran')  h.pendaftaran    = (h.pendaftaran    || 0) + 1;
        if (tipe === 'penetapan')    h.penetapan      = (h.penetapan      || 0) + 1;
        if (tipe === 'pembayaran') {
          h.pembayaran       = (h.pembayaran       || 0) + 1;
          h.total_pendapatan = (h.total_pendapatan || 0) + (item.total || 0);
        }
        return { hariIni: h };
      });
    }
    // Debounce refresh breakdown hari
    if (tipe !== 'pembayaran' && item.type !== undefined) return;
    if (this.state.breakdownMode !== 'hari') return;
    if (this._breakdownRefreshTimer) clearTimeout(this._breakdownRefreshTimer);
    this._breakdownRefreshTimer = setTimeout(() => {
      const { kabupatenParam, uptParam } = this.state;
      this.loadBreakdownHari(kabupatenParam, uptParam);
    }, 5000);
  };

  // Koneksi ws/active-users kini dimiliki tunggal oleh AdminLayout
  // (drawer User Aktif + badge sidebar via redux activeUsersCount).

  componentDidUpdate(prevProps) {
    if (prevProps.uptDipilih !== this.props.uptDipilih) {
      this.getData();
    }
  }

  _uptNamaFromProps() {
    try {
      const raw = this.props.uptDipilih;
      if (!raw) return '';
      const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return obj.nama || '';
    } catch {
      return '';
    }
  }

  async loadBreakdownBulan(bulan, tahun, kabupatenParam, uptParam) {
    this.setState({ loadingBreakdown: true });
    let url = `${configClass.apiUrl.breakdownBulan}?bulan=${bulan}&tahun=${tahun}`;
    if (kabupatenParam) url += `&kabupaten_id=${kabupatenParam}`;
    if (uptParam) url += `&upt_id=${uptParam}`;
    this.props.ajaxViewHandler('get', url)
      .then(() => {
        if (this.props.isSuccess) {
          this.setState({ breakdownBulan: this.props.responseMsg });
        }
        this.setState({ loadingBreakdown: false });
      })
      .catch(() => this.setState({ loadingBreakdown: false }));
  }

  async loadBreakdownHari(kabupatenParam, uptParam) {
    this.setState({ loadingBreakdownHari: true });
    let url = configClass.apiUrl.breakdownHari;
    const params = [];
    if (kabupatenParam) params.push(`kabupaten_id=${kabupatenParam}`);
    if (uptParam) params.push(`upt_id=${uptParam}`);
    if (params.length) url += '?' + params.join('&');
    this.props.ajaxViewHandler('get', url)
      .then(() => {
        if (this.props.isSuccess) {
          this.setState({ breakdownHari: this.props.responseMsg });
        }
        this.setState({ loadingBreakdownHari: false });
      })
      .catch(() => this.setState({ loadingBreakdownHari: false }));
  }

  async getPengumuman() {
    this.setState({ loadingPengumuman: true });
    this.props.ajaxViewHandler('get', configClass.apiUrl.pengumuman + '?limit=20')
      .then(() => {
        const data = this.props.responseMsg;
        if (this.props.isSuccess) {
          const list = Array.isArray(data) ? data : (data.results || []);
          this.setState({ pengumuman: list });
        }
        this.setState({ loadingPengumuman: false });
      })
      .catch(() => this.setState({ loadingPengumuman: false }));
  }

  async submitFormPengumuman() {
    const { formPengumuman } = this.state;
    if (!formPengumuman.judul.trim() || !formPengumuman.isi.trim()) return;
    this.setState({ submitPengumuman: true });
    this.props.ajaxViewHandler('post', configClass.apiUrl.pengumuman, formPengumuman)
      .then(() => {
        if (this.props.isSuccess) {
          message.success({ content: 'Pengumuman berhasil disimpan.', duration: 2, key: 'toast' });
          this.setState({
            isModalPengumuman: false,
            formPengumuman: { judul: '', isi: '', tipe: 'umum', versi: '' },
          });
          this.getPengumuman();
        } else {
          const err = this.props.responseMsg;
          message.error({ content: typeof err === 'string' ? err : (err && err.detail) || 'Gagal menyimpan pengumuman.', duration: 2, key: 'toast' });
        }
        this.setState({ submitPengumuman: false });
      })
      .catch(() => {
        message.error({ content: 'Gagal menyimpan pengumuman.', duration: 2, key: 'toast' });
        this.setState({ submitPengumuman: false });
      });
  }

  async updatePengumuman() {
    const { editPengumuman } = this.state;
    if (!editPengumuman || !editPengumuman.judul.trim() || !editPengumuman.isi.trim()) return;
    this.setState({ submitPengumuman: true });
    this.props.ajaxViewHandler('put', configClass.apiUrl.pengumuman + editPengumuman.id + '/', editPengumuman)
      .then(() => {
        if (this.props.isSuccess) {
          message.success({ content: 'Pengumuman berhasil diperbarui.', duration: 2, key: 'toast' });
          this.setState({ isEditModalPengumuman: false, editPengumuman: null });
          this.getPengumuman();
        } else {
          const err = this.props.responseMsg;
          message.error({ content: typeof err === 'string' ? err : (err && err.detail) || 'Gagal memperbarui pengumuman.', duration: 2, key: 'toast' });
        }
        this.setState({ submitPengumuman: false });
      })
      .catch(() => {
        message.error({ content: 'Gagal memperbarui pengumuman.', duration: 2, key: 'toast' });
        this.setState({ submitPengumuman: false });
      });
  }

  async togglePengumuman(item) {
    this.setState({ loadingTogglePengumuman: item.id });
    const newStatus = !item.is_aktif;
    this.props.ajaxViewHandler('patch', configClass.apiUrl.pengumuman + item.id + '/', { is_aktif: newStatus })
      .then(() => {
        if (this.props.isSuccess) {
          message.success({ content: newStatus ? 'Pengumuman diaktifkan.' : 'Pengumuman dinonaktifkan.', duration: 2, key: 'toast' });
          this.getPengumuman();
        } else {
          message.error({ content: 'Gagal mengubah status pengumuman.', duration: 2, key: 'toast' });
        }
        this.setState({ loadingTogglePengumuman: null });
      })
      .catch(() => {
        message.error({ content: 'Gagal mengubah status pengumuman.', duration: 2, key: 'toast' });
        this.setState({ loadingTogglePengumuman: null });
      });
  }

  async loadKabupaten() {
    this.setState({ loadingFilter: true });
    await this.props.ajaxViewHandler('get', configClass.apiUrl.kabupaten + '?limit=100');
    const data = this.props.responseMsg;
    if (this.props.isSuccess) {
      const list = Array.isArray(data) ? data : (data.results || []);
      this.setState({ listKabupaten: list });
    }
    this.setState({ loadingFilter: false });
  }

  async loadUpt(kabupatenId) {
    if (!kabupatenId) { this.setState({ listUpt: [] }); return; }
    this.setState({ loadingFilter: true });
    await this.props.ajaxViewHandler('get', `${configClass.apiUrl.upt}?kabupaten=${kabupatenId}&limit=100`);
    const data = this.props.responseMsg;
    if (this.props.isSuccess) {
      const list = Array.isArray(data) ? data : (data.results || []);
      this.setState({ listUpt: list });
    }
    this.setState({ loadingFilter: false });
  }

  async getData(kabupatenId = null, uptId = null) {
    this.setState({ loading: true });
    this.getPengumuman();

    let url = configClass.apiUrl.dashboard;
    const params = [];
    if (kabupatenId) params.push(`kabupaten_id=${kabupatenId}`);
    if (uptId) params.push(`upt_id=${uptId}`);
    if (params.length) url += '?' + params.join('&');

    this.props.ajaxViewHandler('get', url)
      .then(async () => {
        const data = this.props.responseMsg;
        if (this.props.isSuccess) {
          const tahun = data.tahun || new Date().getFullYear();
          const tahunLalu = data.tahun_lalu || tahun - 1;
          const cakupan = data.cakupan_user || 0;
          const perUptData = data.grafik_per_upt || [];

          this.setState({
            levelUser: Number(data.level_user) || 3,
            isSuperuser: data.is_superuser || false,
            cakupan_user: cakupan,
            uptNama: data.upt_nama || this._uptNamaFromProps(),
            tahun,
            tahunLalu,
            hariIni: data.hari_ini,
            bulanIni: data.bulan_ini,
            showPerUpt: ([1, 2].includes(cakupan) || data.is_superuser) && perUptData.length > 0 && !uptId,
            grafikPerUpt: perUptData.length ? buildGrafikPerUpt(perUptData) : { labels: [], datasets: [] },
            grafikHarian: data.grafik_harian && data.grafik_harian.length
              ? buildGrafikHarian(
                data.grafik_harian,
                data.grafik_harian_lalu || [],
                tahun,
                tahunLalu,
              )
              : emptyHarian,
            grafikBulanan: data.grafik_bulanan && data.grafik_bulanan.length
              ? buildGrafikBulanan(data.grafik_bulanan, tahun, tahunLalu) : emptyBulanan,
            pemutihan: data.pemutihan || null,
            breakdownBulanSelected: new Date().getMonth() + 1,
            breakdownTahunSelected: tahun,
            // Fitur tambahan
            distribusiLayanan: data.distribusi_layanan || [],
            kendaraanJatuhTempo: data.kendaraan_jatuh_tempo || { h7: 0, h14: 0, h30: 0 },
            grafikJam: data.grafik_jam || [],
            distribusiJenisKendaraan: data.distribusi_jenis_kendaraan || [],
            rataRataWaktu: data.rata_rata_waktu || { daftar_ke_penetapan: 0, penetapan_ke_pembayaran: 0, total: 0, jumlah_sampel: 0 },
            rankingUpt: data.ranking_upt || [],
            targetRealisasi: data.target_realisasi || null,
          });
          this.loadBreakdownBulan(
            new Date().getMonth() + 1, tahun, kabupatenId, uptId
          );
          this.loadBreakdownHari(kabupatenId, uptId);

          // Muat dropdown setelah tahu cakupan_user
          if (cakupan === 1 && this.state.listKabupaten.length === 0) {
            await this.loadKabupaten();
          }
          if ([1, 2].includes(cakupan)) {
            const kabId = kabupatenId || data.kabupaten_id_user;
            if (kabId && this.state.listUpt.length === 0) {
              await this.loadUpt(kabId);
            }
          }
        }
        this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const {
      loading, hariIni, bulanIni, grafikHarian, grafikBulanan, uptNama, tahun, tahunLalu,
      pengumuman, loadingPengumuman, levelUser, isSuperuser,
      cakupan_user, kabupatenParam, uptParam, listKabupaten, listUpt, loadingFilter,
      grafikPerUpt, showPerUpt, pemutihan,
      breakdownBulan, breakdownBulanSelected, breakdownTahunSelected, loadingBreakdown,
      breakdownMode, breakdownHari, loadingBreakdownHari,
      distribusiLayanan, kendaraanJatuhTempo, grafikJam,
      distribusiJenisKendaraan, rataRataWaktu, rankingUpt, targetRealisasi,
      detailModalStatus,
    } = this.state;
    const namaUpt = uptNama || this._uptNamaFromProps() || 'Semua UPT';

    const cardStyle = {
      borderRadius: 10,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      height: '100%',
    };

    const iconBox = (icon, warna) => (
      <div style={{
        width: 52, height: 52, borderRadius: 12,
        background: warna, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        fontSize: 26, color: '#fff', flexShrink: 0,
      }}>
        {icon}
      </div>
    );

    const kartuHariIni = [
      { label: 'Pendaftaran Hari Ini', value: hariIni.pendaftaran, icon: <FileAddOutlined />, warna: WARNA.biru, statusKey: 'pendaftaran' },
      { label: 'Penetapan Hari Ini', value: hariIni.penetapan, icon: <CheckSquareOutlined />, warna: WARNA.oranye, statusKey: 'penetapan' },
      { label: 'Pembayaran Hari Ini', value: hariIni.pembayaran, icon: <DollarOutlined />, warna: WARNA.hijau, statusKey: 'pembayaran' },
      {
        label: 'Pendapatan Hari Ini',
        value: `Rp ${(hariIni.total_pendapatan || 0).toLocaleString('id-ID')}`,
        icon: <BankOutlined />, warna: WARNA.ungu, isRupiah: true,
        breakdown: hariIni.breakdown,
      },
    ];

    return (
      <div>
        <Helmet>
          <title>{configClass.title + ' | ' + config.get_site_info().name}</title>
        </Helmet>

        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item><HomeOutlined /> Home</Breadcrumb.Item>
          <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        </Breadcrumb>

        {/* Chip UPT — hanya tampil untuk non-superadmin */}
        {!isSuperuser && this._uptNamaFromProps() && (
          <div style={{ marginBottom: 14, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
            <div className="upt-aktif upt-green" style={{ cursor: 'default' }}>
              <div className="upt-dot" />
              <div className="upt-text-group">
                <span className="upt-nama">{this._uptNamaFromProps()}</span>
              </div>
            </div>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => this.getData(kabupatenParam, uptParam)}
              loading={loading}
              type="primary"
              ghost
              size="small"
            >
              Refresh
            </Button>
          </div>
        )}

        {/* Tombol Refresh untuk superadmin (tanpa chip UPT) */}
        {isSuperuser && (
          <div style={{ marginBottom: 14, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => this.getData(kabupatenParam, uptParam)}
              loading={loading}
              type="primary"
              ghost
              size="small"
            >
              Refresh
            </Button>
          </div>
        )}

        {/* ===== Filter Bar (hanya cakupan 1 & 2) ===== */}
        {[1, 2].includes(cakupan_user) && (
          <Card
            size="small"
            style={{ marginBottom: 14, borderRadius: 10, border: '1px solid #e6f4ff', background: '#f0f7ff' }}
            bodyStyle={{ padding: '10px 16px' }}
          >
            <Row align="middle" gutter={[12, 8]}>
              <Col flex="none">
                <FilterOutlined style={{ color: WARNA.biru, fontSize: 15 }} />
                <Text style={{ marginLeft: 6, fontWeight: 600, color: '#333', fontSize: 13 }}>Filter Data:</Text>
              </Col>

              {/* Kabupaten (hanya cakupan 1) */}
              {cakupan_user === 1 && (
                <Col flex="220px">
                  <Select
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Semua Kabupaten"
                    size="small"
                    loading={loadingFilter}
                    filterOption={(input, opt) => opt.children.toLowerCase().includes(input.toLowerCase())}
                    value={kabupatenParam}
                    onChange={async val => {
                      this.setState({ kabupatenParam: val || null, uptParam: null, listUpt: [] });
                      if (val) await this.loadUpt(val);
                      this.getData(val || null, null);
                    }}
                  >
                    {listKabupaten.map(k => (
                      <Select.Option key={k.id} value={k.id}>{k.name}</Select.Option>
                    ))}
                  </Select>
                </Col>
              )}

              {/* UPT — untuk cakupan 1 hanya tampil setelah kabupaten dipilih */}
              {(cakupan_user === 2 || (cakupan_user === 1 && kabupatenParam)) && (
                <Col flex="220px">
                  <Select
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Semua UPT"
                    size="small"
                    loading={loadingFilter}
                    filterOption={(input, opt) => opt.children.toLowerCase().includes(input.toLowerCase())}
                    value={uptParam}
                    onChange={val => {
                      this.setState({ uptParam: val || null });
                      this.getData(kabupatenParam, val || null);
                    }}
                  >
                    {listUpt.map(u => (
                      <Select.Option key={u.id} value={u.id}>{u.nama}</Select.Option>
                    ))}
                  </Select>
                </Col>
              )}

              {(kabupatenParam || uptParam) && (
                <Col flex="none">
                  <Button
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => {
                      this.setState({ kabupatenParam: null, uptParam: null, listUpt: [] });
                      this.getData(null, null);
                    }}
                  >
                    Reset
                  </Button>
                </Col>
              )}
            </Row>
          </Card>
        )}

        <Spin spinning={loading}>

          {/* === Kartu Hari Ini === */}
          <Row gutter={[12, 12]}>
            {kartuHariIni.map((k, i) => (
              <Col key={i} xs={24} sm={12} lg={6}>
                <Card
                  style={{ ...cardStyle, cursor: k.statusKey ? 'pointer' : 'default' }}
                  bodyStyle={{ padding: '16px 20px' }}
                  hoverable={!!k.statusKey}
                  onClick={() => k.statusKey && this.setState({ detailModalStatus: k.statusKey })}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    {iconBox(k.icon, k.warna)}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, color: '#888', marginBottom: 2 }}>{k.label}</div>
                      {k.isRupiah
                        ? <div style={{ fontSize: 16, fontWeight: 700, color: k.warna, lineHeight: 1.3 }}>{k.value}</div>
                        : <Statistic value={k.value} groupSeparator="." valueStyle={{ fontSize: 28, fontWeight: 700, color: k.warna, lineHeight: 1 }} />
                      }
                      {k.breakdown && (() => {
                        const bd = k.breakdown;
                        const tot = o => typeof o === 'object' ? Object.values(o).reduce((a, b) => a + (b || 0), 0) : (o || 0);
                        const rp = v => `Rp ${(v || 0).toLocaleString('id-ID')}`;
                        return (
                          <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {[
                              { l: 'PKB', v: tot(bd.pkb), c: '#52c41a' },
                              { l: 'Opsen PKB', v: tot(bd.opsen_pkb), c: '#722ed1' },
                              { l: 'BBNKB', v: tot(bd.bbnkb), c: '#1890ff' },
                              { l: 'Opsen BBNKB', v: tot(bd.opsen_bbnkb), c: '#9254de' },
                              { l: 'SWDKLLJ', v: tot(bd.swdkllj), c: '#fa8c16' },
                              { l: 'Adm STNK', v: bd.admstnk, c: '#13c2c2' },
                              { l: 'Adm TNKB', v: bd.admtnk, c: '#eb2f96' },
                            ].map(x => (
                              <Tooltip key={x.l} title={`${x.l}: ${rp(x.v)}`}>
                                <span style={{
                                  fontSize: 9, fontWeight: 700, color: x.c,
                                  background: `${x.c}18`, borderRadius: 4,
                                  padding: '1px 5px', cursor: 'default',
                                }}>
                                  {x.l}
                                </span>
                              </Tooltip>
                            ))}
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {/* === Ringkasan Bulan Ini === */}
          <Card
            style={{ ...cardStyle, marginTop: 12 }}
            bodyStyle={{ padding: '12px 20px' }}
          >
            <Row align="middle" gutter={[16, 8]} wrap>
              <Col><Text strong style={{ fontSize: 13 }}>Bulan Ini:</Text></Col>
              <Col>
                <Text style={{ color: WARNA.biru }}>
                  <FileAddOutlined /> Pendaftaran: <strong>{(bulanIni.pendaftaran || 0).toLocaleString('id-ID')}</strong>
                </Text>
              </Col>
              <Col>
                <Text style={{ color: WARNA.oranye }}>
                  <CheckSquareOutlined /> Penetapan: <strong>{(bulanIni.penetapan || 0).toLocaleString('id-ID')}</strong>
                </Text>
              </Col>
              <Col>
                <Text style={{ color: WARNA.hijau }}>
                  <DollarOutlined /> Pembayaran: <strong>{(bulanIni.pembayaran || 0).toLocaleString('id-ID')}</strong>
                </Text>
              </Col>
              <Col>
                <Text style={{ color: WARNA.ungu }}>
                  <BankOutlined /> Pendapatan: <strong>Rp {(bulanIni.total_pendapatan || 0).toLocaleString('id-ID')}</strong>
                </Text>
              </Col>
            </Row>
          </Card>

          {/* === Rincian Pendapatan === */}
          {(() => {
            // Pilih sumber data berdasarkan mode
            const isHari = breakdownMode === 'hari';
            const bd = isHari
              ? (breakdownHari ? breakdownHari.breakdown : null)
              : (breakdownBulan ? breakdownBulan.breakdown : bulanIni.breakdown);
            const loading = isHari ? loadingBreakdownHari : loadingBreakdown;

            const rp = v => (v || 0).toLocaleString('id-ID');
            const tot = o => Object.values(o).reduce((a, b) => a + (b || 0), 0);
            const BULAN_NAMA = ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
              'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

            const thStyle = { padding: '6px 10px', fontSize: 11, fontWeight: 700, color: '#555', background: '#f5f5f5', borderBottom: '1px solid #e8e8e8', whiteSpace: 'nowrap', textAlign: 'right' };
            const thLabelStyle = { ...thStyle, textAlign: 'left' };
            const tdStyle = { padding: '5px 10px', fontSize: 11, color: '#333', textAlign: 'right', whiteSpace: 'nowrap', borderBottom: '1px solid #f0f0f0' };
            const tdLabelStyle = { ...tdStyle, textAlign: 'left', fontWeight: 600 };
            const tdTotalStyle = { ...tdStyle, fontWeight: 700 };
            const tdDashStyle = { ...tdStyle, color: '#ccc' };
            const trTotalStyle = { background: '#fafafa', borderTop: '2px solid #e8e8e8' };

            // Jika data belum ada, tetap render Card dengan Spin agar toggle terlihat
            if (!bd) {
              return (
                <Card style={{ ...cardStyle, marginTop: 8 }} bodyStyle={{ padding: 0 }}
                  title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 12, color: '#888', fontWeight: 600, letterSpacing: 0.5 }}>RINCIAN PENDAPATAN</span>
                      <Radio.Group value={breakdownMode} buttonStyle="solid" size="small"
                        onChange={e => {
                          const mode = e.target.value;
                          this.setState({ breakdownMode: mode });
                          if (mode === 'hari' && !breakdownHari) this.loadBreakdownHari(kabupatenParam, uptParam);
                        }}>
                        <Radio.Button value="hari">Hari Ini</Radio.Button>
                        <Radio.Button value="bulan">Bulan Ini</Radio.Button>
                      </Radio.Group>
                    </div>
                  }
                  headStyle={{ minHeight: 44, padding: '0 16px', borderBottom: '1px solid #f0f0f0' }}
                >
                  <div style={{ padding: 24, textAlign: 'center' }}>
                    <Spin spinning={loading}><span style={{ color: '#aaa', fontSize: 13 }}>Memuat data...</span></Spin>
                  </div>
                </Card>
              );
            }

            const rows = [
              {
                label: 'PKB', warna: '#52c41a',
                cols: [bd.pkb.pokok, bd.pkb.denda, bd.pkb.tunggakan_pokok, bd.pkb.tunggakan_denda],
                total: tot(bd.pkb),
              },
              {
                label: 'Opsen PKB', warna: '#722ed1',
                cols: [bd.opsen_pkb.pokok, bd.opsen_pkb.denda, bd.opsen_pkb.tunggakan_pokok, bd.opsen_pkb.tunggakan_denda],
                total: tot(bd.opsen_pkb),
              },
              {
                label: 'SWDKLLJ', warna: '#fa8c16',
                cols: [bd.swdkllj.pokok, bd.swdkllj.denda, bd.swdkllj.tunggakan_pokok, bd.swdkllj.tunggakan_denda],
                total: tot(bd.swdkllj),
              },
              {
                label: 'BBNKB', warna: '#1890ff',
                cols: [bd.bbnkb.pokok, bd.bbnkb.denda, null, null],
                total: tot(bd.bbnkb),
              },
              {
                label: 'Opsen BBNKB', warna: '#9254de',
                cols: [bd.opsen_bbnkb.pokok, bd.opsen_bbnkb.denda, null, null],
                total: tot(bd.opsen_bbnkb),
              },
              {
                label: 'Adm STNK', warna: '#13c2c2',
                cols: [bd.admstnk, null, null, null],
                total: bd.admstnk,
              },
              {
                label: 'Adm TNKB', warna: '#eb2f96',
                cols: [bd.admtnk, null, null, null],
                total: bd.admtnk,
              },
            ];

            const grandTotal = rows.reduce((a, r) => a + r.total, 0);

            return (
              <Card
                style={{ ...cardStyle, marginTop: 8 }}
                bodyStyle={{ padding: '0' }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: '#888', fontWeight: 600, letterSpacing: 0.5 }}>
                      RINCIAN PENDAPATAN
                    </span>
                    {/* Toggle Hari Ini / Bulan Ini */}
                    <Radio.Group
                      value={breakdownMode}
                      buttonStyle="solid"
                      size="small"
                      onChange={e => {
                        const mode = e.target.value;
                        this.setState({ breakdownMode: mode });
                        if (mode === 'hari' && !breakdownHari) {
                          this.loadBreakdownHari(kabupatenParam, uptParam);
                        }
                      }}
                    >
                      <Radio.Button value="hari">Hari Ini</Radio.Button>
                      <Radio.Button value="bulan">Bulan Ini</Radio.Button>
                    </Radio.Group>
                    {/* Pilih bulan/tahun — hanya tampil saat mode bulan */}
                    {!isHari && (
                      <>
                        <Select
                          size="small"
                          value={breakdownBulanSelected}
                          style={{ width: 120 }}
                          loading={loadingBreakdown}
                          onChange={val => {
                            this.setState({ breakdownBulanSelected: val });
                            this.loadBreakdownBulan(val, breakdownTahunSelected, kabupatenParam, uptParam);
                          }}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
                            <Select.Option key={m} value={m}>{BULAN_NAMA[m]}</Select.Option>
                          ))}
                        </Select>
                        <Select
                          size="small"
                          value={breakdownTahunSelected}
                          style={{ width: 80 }}
                          loading={loadingBreakdown}
                          onChange={val => {
                            this.setState({ breakdownTahunSelected: val });
                            this.loadBreakdownBulan(breakdownBulanSelected, val, kabupatenParam, uptParam);
                          }}
                        >
                          {[tahun - 1, tahun].map(y => (
                            <Select.Option key={y} value={y}>{y}</Select.Option>
                          ))}
                        </Select>
                      </>
                    )}
                    {/* Label tanggal hari ini */}
                    {isHari && breakdownHari && (
                      <span style={{ fontSize: 11, color: '#aaa' }}>{breakdownHari.tanggal}</span>
                    )}
                  </div>
                }
                headStyle={{ minHeight: 44, padding: '0 16px', borderBottom: '1px solid #f0f0f0' }}
              >
                <Spin spinning={loading}>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={thLabelStyle}>Komponen</th>
                          <th style={thStyle}>Pokok</th>
                          <th style={thStyle}>Denda</th>
                          <th style={thStyle}>Tunggakan Pokok</th>
                          <th style={thStyle}>Tunggakan Denda</th>
                          <th style={{ ...thStyle, color: '#1890ff' }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map(row => (
                          <tr key={row.label}>
                            <td style={tdLabelStyle}>
                              <span style={{
                                display: 'inline-block', width: 8, height: 8,
                                borderRadius: '50%', background: row.warna,
                                marginRight: 6,
                              }} />
                              {row.label}
                            </td>
                            {row.cols.map((val, ci) => (
                              <td key={ci} style={val === null ? tdDashStyle : tdStyle}>
                                {val === null ? '—' : rp(val)}
                              </td>
                            ))}
                            <td style={tdTotalStyle}>{rp(row.total)}</td>
                          </tr>
                        ))}
                        <tr style={trTotalStyle}>
                          <td style={{ ...tdLabelStyle, fontWeight: 700, fontSize: 12 }}>TOTAL</td>
                          <td colSpan={4} />
                          <td style={{ ...tdTotalStyle, fontSize: 12, color: '#1890ff' }}>
                            {rp(grandTotal)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Spin>
              </Card>
            );
          })()}

          {/* ===== INDIKATOR PEMUTIHAN ===== */}
          {levelUser <= 2 && pemutihan && (() => {
            const selisihBulan = (pemutihan.pembayaran_bulan_ini || 0) - (pemutihan.pembayaran_bulan_sama_lalu || 0);
            const selisihTahun = (pemutihan.total_pembayaran_tahun_ini || 0) - (pemutihan.total_pembayaran_tahun_lalu || 0);
            const pctBulan = pemutihan.pembayaran_bulan_sama_lalu > 0
              ? Math.round(selisihBulan / pemutihan.pembayaran_bulan_sama_lalu * 100) : null;
            const pctTahun = pemutihan.total_pembayaran_tahun_lalu > 0
              ? Math.round(selisihTahun / pemutihan.total_pembayaran_tahun_lalu * 100) : null;
            return (
              <>
                <Divider style={{ margin: '16px 0 10px' }}>
                  <span style={{ fontSize: 12, color: '#888', fontWeight: 500, letterSpacing: 1 }}>
                    INDIKATOR KEBIJAKAN PEMUTIHAN PAJAK
                  </span>
                </Divider>
                <Row gutter={[10, 10]} style={{ marginBottom: 4 }}>

                  {/* 1. Kendaraan jatuh tempo belum bayar */}
                  <Col xs={24} sm={12} lg={6}>
                    <Card bodyStyle={{ padding: '14px 18px' }} style={{ ...cardStyle, borderLeft: '4px solid #f5222d' }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Kendaraan Jatuh Tempo Belum Bayar</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: 10, background: '#fff1f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <CalendarOutlined style={{ color: '#f5222d', fontSize: 22 }} />
                        </div>
                        <div>
                          <div style={{ fontSize: 26, fontWeight: 800, color: '#f5222d', lineHeight: 1 }}>
                            {(pemutihan.kendaraan_belum_bayar || 0).toLocaleString('id-ID')}
                          </div>
                          <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>kendaraan (sd_notice ≤ hari ini)</div>
                        </div>
                      </div>
                    </Card>
                  </Col>

                  {/* 2. Tren pembayaran bulan ini vs bulan sama tahun lalu */}
                  <Col xs={24} sm={12} lg={6}>
                    <Card bodyStyle={{ padding: '14px 18px' }} style={{ ...cardStyle, borderLeft: `4px solid ${selisihBulan >= 0 ? '#52c41a' : '#f5222d'}` }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Tren Pembayaran Bulan Ini</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: 10, background: selisihBulan >= 0 ? '#f6ffed' : '#fff1f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <DollarOutlined style={{ color: selisihBulan >= 0 ? '#52c41a' : '#f5222d', fontSize: 22 }} />
                        </div>
                        <div>
                          <div style={{ fontSize: 26, fontWeight: 800, color: '#222', lineHeight: 1 }}>
                            {(pemutihan.pembayaran_bulan_ini || 0).toLocaleString('id-ID')}
                          </div>
                          <div style={{ fontSize: 10, color: selisihBulan >= 0 ? '#52c41a' : '#f5222d', marginTop: 2, fontWeight: 600 }}>
                            {selisihBulan >= 0 ? '+' : ''}{selisihBulan.toLocaleString('id-ID')}
                            {pctBulan !== null ? ` (${pctBulan >= 0 ? '+' : ''}${pctBulan}%)` : ''} vs {pemutihan.tahun_lalu}
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>

                  {/* 3. Nilai tunggakan PKB */}
                  <Col xs={24} sm={12} lg={6}>
                    <Card bodyStyle={{ padding: '14px 18px' }} style={{ ...cardStyle, borderLeft: '4px solid #fa8c16' }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Total Nilai Tunggakan PKB</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: 10, background: '#fff7e6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <BankOutlined style={{ color: '#fa8c16', fontSize: 22 }} />
                        </div>
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 800, color: '#fa8c16', lineHeight: 1.4 }}>
                            Rp {(pemutihan.nilai_tunggakan || 0).toLocaleString('id-ID')}
                          </div>
                          <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>akumulasi tunggakan pokok + denda PKB</div>
                        </div>
                      </div>
                    </Card>
                  </Col>

                  {/* 4. Perbandingan total pembayaran tahun ini vs tahun lalu */}
                  <Col xs={24} sm={12} lg={6}>
                    <Card bodyStyle={{ padding: '14px 18px' }} style={{ ...cardStyle, borderLeft: `4px solid ${selisihTahun >= 0 ? '#722ed1' : '#f5222d'}` }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Total Pembayaran {pemutihan.tahun} vs {pemutihan.tahun_lalu}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: 10, background: '#f9f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <ReloadOutlined style={{ color: '#722ed1', fontSize: 22 }} />
                        </div>
                        <div>
                          <div style={{ fontSize: 26, fontWeight: 800, color: '#222', lineHeight: 1 }}>
                            {(pemutihan.total_pembayaran_tahun_ini || 0).toLocaleString('id-ID')}
                          </div>
                          <div style={{ fontSize: 10, marginTop: 2, fontWeight: 600, color: selisihTahun >= 0 ? '#722ed1' : '#f5222d' }}>
                            {selisihTahun >= 0 ? '+' : ''}{selisihTahun.toLocaleString('id-ID')}
                            {pctTahun !== null ? ` (${pctTahun >= 0 ? '+' : ''}${pctTahun}%)` : ''} vs {pemutihan.tahun_lalu}
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>

                </Row>
              </>
            );
          })()}

          {/* ===== TARGET vs REALISASI ===== */}
          {(() => {
            const bulanSekarang = new Date().getMonth() + 1;
            const rp = v => (v || 0).toLocaleString('id-ID');
            const thS = { padding: '7px 10px', fontSize: 11, fontWeight: 700, background: '#fafafa', borderBottom: '1px solid #e8e8e8', textAlign: 'right', whiteSpace: 'nowrap' };
            const thL = { ...thS, textAlign: 'left' };
            const tdS = { padding: '6px 10px', fontSize: 11, textAlign: 'right', borderBottom: '1px solid #f5f5f5', whiteSpace: 'nowrap' };
            const tdL = { ...tdS, textAlign: 'left', fontWeight: 600 };
            const pctColor = p => p >= 80 ? '#52c41a' : p >= 50 ? '#fa8c16' : '#f5222d';

            // Prompt Bapenda (cakupan=1) yang belum pilih kabupaten — superadmin langsung tampil summary
            if (!targetRealisasi && !kabupatenParam && cakupan_user === 1 && !isSuperuser) {
              return (
                <Card style={{ ...cardStyle, marginTop: 12 }} bodyStyle={{ padding: '20px 24px' }}
                  title={<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <RiseOutlined style={{ color: '#52c41a', fontSize: 16 }} />
                    <span style={{ fontWeight: 700, fontSize: 13 }}>Target vs Realisasi</span>
                  </div>}>
                  <div style={{ textAlign: 'center', color: '#aaa', padding: '12px 0' }}>
                    <RiseOutlined style={{ fontSize: 32, marginBottom: 8 }} />
                    <div style={{ fontSize: 13 }}>Pilih <strong>Kabupaten/Kota</strong> pada filter di atas untuk melihat Target vs Realisasi.</div>
                  </div>
                </Card>
              );
            }

            if (!targetRealisasi) return null;

            // ===== MODE SUMMARY (superadmin, semua kabupaten) =====
            if (targetRealisasi.mode === 'summary') {
              const {
                kabupaten: kabList, total_target, total_realisasi, persen_capai: pctAll, tahun: thn,
                total_pkb_t, total_bbnkb_t, total_pkb_r, total_bbnkb_r,
                n_hijau = 0, n_kuning = 0, n_merah = 0,
              } = targetRealisasi;

              const rankIcon = i => {
                if (i === 0) return <span style={{ fontSize: 14 }}>🥇</span>;
                if (i === 1) return <span style={{ fontSize: 14 }}>🥈</span>;
                if (i === 2) return <span style={{ fontSize: 14 }}>🥉</span>;
                return <span style={{ color: '#bbb', fontSize: 11 }}>{i + 1}</span>;
              };

              const statusBadge = (n, warna, label) => n > 0 && (
                <span style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4,
                  background: `${warna}18`, border: `1px solid ${warna}55`,
                  borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700, color: warna,
                }}>
                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: warna, display: 'inline-block' }} />
                  {n} kab {label}
                </span>
              );

              return (
                <Card style={{ ...cardStyle, marginTop: 12 }} bodyStyle={{ padding: 0 }}
                  title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', padding: '4px 0' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <RiseOutlined style={{ color: '#52c41a', fontSize: 16 }} />
                        <span style={{ fontWeight: 700, fontSize: 13 }}>Target vs Realisasi {thn} — Semua Kabupaten/Kota</span>
                      </div>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        {statusBadge(n_hijau,  '#52c41a', '≥80%')}
                        {statusBadge(n_kuning, '#fa8c16', '50–80%')}
                        {statusBadge(n_merah,  '#f5222d', '<50%')}
                      </div>
                      <span style={{ marginLeft: 'auto', fontSize: 12, color: '#555' }}>
                        Total:&nbsp;
                        <strong style={{ color: pctColor(pctAll) }}>{pctAll}%</strong>
                        &nbsp;
                        <span style={{ color: '#888' }}>Rp {rp(total_realisasi)} / Rp {rp(total_target)}</span>
                      </span>
                    </div>
                  }
                  headStyle={{ minHeight: 52, padding: '0 16px', borderBottom: '1px solid #f0f0f0' }}
                >
                  {/* KPI Aggregate */}
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
                    <Row gutter={[10, 10]}>
                      <Col xs={24} sm={12} lg={6}>
                        <div style={{ borderRadius: 8, padding: '12px 14px', background: '#f0f7ff', borderTop: '1px solid #bae0ff', borderRight: '1px solid #bae0ff', borderBottom: '1px solid #bae0ff', borderLeft: '4px solid #1890ff' }}>
                          <div style={{ fontSize: 10, color: '#888', marginBottom: 4 }}>Total Target {thn}</div>
                          <div style={{ fontSize: 14, fontWeight: 800, color: '#1890ff' }}>Rp {rp(total_target)}</div>
                          <div style={{ fontSize: 10, color: '#999', marginTop: 3 }}>PKB: Rp {rp(total_pkb_t)} | BBNKB: Rp {rp(total_bbnkb_t)}</div>
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={6}>
                        <div style={{ borderRadius: 8, padding: '12px 14px', background: '#f6ffed', borderTop: '1px solid #b7eb8f', borderRight: '1px solid #b7eb8f', borderBottom: '1px solid #b7eb8f', borderLeft: `4px solid ${pctColor(pctAll)}` }}>
                          <div style={{ fontSize: 10, color: '#888', marginBottom: 4 }}>Total Realisasi YTD</div>
                          <div style={{ fontSize: 14, fontWeight: 800, color: pctColor(pctAll) }}>Rp {rp(total_realisasi)}</div>
                          <div style={{ fontSize: 10, color: '#999', marginTop: 3 }}>PKB: Rp {rp(total_pkb_r)} | BBNKB: Rp {rp(total_bbnkb_r)}</div>
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={6}>
                        <div style={{ borderRadius: 8, padding: '12px 14px', background: '#fffbe6', borderTop: '1px solid #ffe58f', borderRight: '1px solid #ffe58f', borderBottom: '1px solid #ffe58f', borderLeft: '4px solid #faad14' }}>
                          <div style={{ fontSize: 10, color: '#888', marginBottom: 4 }}>Capaian Keseluruhan</div>
                          <div style={{ fontSize: 20, fontWeight: 800, color: pctColor(pctAll), lineHeight: 1 }}>{pctAll}%</div>
                          <div style={{ marginTop: 6, height: 6, background: '#f0f0f0', borderRadius: 3 }}>
                            <div style={{ height: '100%', width: `${Math.min(pctAll, 100)}%`, background: pctColor(pctAll), borderRadius: 3 }} />
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={6}>
                        <div style={{ borderRadius: 8, padding: '12px 14px', background: '#f9f0ff', borderTop: '1px solid #d3adf7', borderRight: '1px solid #d3adf7', borderBottom: '1px solid #d3adf7', borderLeft: '4px solid #722ed1' }}>
                          <div style={{ fontSize: 10, color: '#888', marginBottom: 4 }}>Status Kabupaten/Kota</div>
                          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
                            {[['🟢', n_hijau, '≥80%'], ['🟡', n_kuning, '50–80%'], ['🔴', n_merah, '<50%']].map(([ic, n, lb]) => (
                              <div key={lb} style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 16 }}>{ic}</div>
                                <div style={{ fontSize: 13, fontWeight: 800 }}>{n}</div>
                                <div style={{ fontSize: 9, color: '#aaa' }}>{lb}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Tabel Ranking */}
                  <div style={{ overflowX: 'auto' }}>
                    <div style={{ padding: '8px 16px 4px', fontSize: 11, color: '#aaa' }}>
                      Diurutkan berdasarkan capaian tertinggi · Klik baris untuk melihat rincian per bulan
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ ...thS, textAlign: 'center', width: 40 }}>#</th>
                          <th style={thL}>Kabupaten/Kota</th>
                          <th style={{ ...thS, textAlign: 'center', borderLeft: '1px solid #e8e8e8' }} colSpan={2}>PKB</th>
                          <th style={{ ...thS, textAlign: 'center', borderLeft: '1px solid #e8e8e8' }} colSpan={2}>BBNKB</th>
                          <th style={{ ...thS, borderLeft: '1px solid #e8e8e8' }}>Total Realisasi</th>
                          <th style={{ ...thS, minWidth: 150 }}>Capaian</th>
                        </tr>
                        <tr style={{ background: '#fafafa' }}>
                          <th style={{ ...thS, borderTop: 0 }} />
                          <th style={{ ...thL, borderTop: 0 }} />
                          <th style={{ ...thS, borderTop: 0, borderLeft: '1px solid #e8e8e8', fontSize: 10 }}>Target</th>
                          <th style={{ ...thS, borderTop: 0, fontSize: 10 }}>Realisasi</th>
                          <th style={{ ...thS, borderTop: 0, borderLeft: '1px solid #e8e8e8', fontSize: 10 }}>Target</th>
                          <th style={{ ...thS, borderTop: 0, fontSize: 10 }}>Realisasi</th>
                          <th style={{ ...thS, borderTop: 0, borderLeft: '1px solid #e8e8e8' }} />
                          <th style={{ ...thS, borderTop: 0 }} />
                        </tr>
                      </thead>
                      <tbody>
                        {kabList.map((k, i) => {
                          const pct = k.persen_capai || 0;
                          const rowBg = i === 0 ? '#fffbe6' : i === 1 ? '#f6ffed' : i === 2 ? '#f0f7ff' : '';
                          return (
                            <tr key={k.kabupaten_id}
                              style={{ background: rowBg, cursor: 'pointer', transition: 'background 0.15s' }}
                              onMouseEnter={e => { if (!rowBg) e.currentTarget.style.background = '#f5f5f5'; }}
                              onMouseLeave={e => { e.currentTarget.style.background = rowBg; }}
                              onClick={() => {
                                this.setState({ kabupatenParam: k.kabupaten_id });
                                this.getData(k.kabupaten_id, null);
                              }}
                            >
                              <td style={{ ...tdS, textAlign: 'center', width: 40 }}>{rankIcon(i)}</td>
                              <td style={{ ...tdL, fontWeight: i < 3 ? 800 : 600 }}>
                                {k.kabupaten_nama}
                              </td>
                              <td style={{ ...tdS, borderLeft: '1px solid #f0f0f0' }}>{rp(k.target_pkb)}</td>
                              <td style={{ ...tdS, color: '#52c41a', fontWeight: 600 }}>{rp(k.realisasi_pkb || 0)}</td>
                              <td style={{ ...tdS, borderLeft: '1px solid #f0f0f0' }}>{rp(k.target_bbnkb)}</td>
                              <td style={{ ...tdS, color: '#1890ff', fontWeight: 600 }}>{rp(k.realisasi_bbnkb || 0)}</td>
                              <td style={{ ...tdS, fontWeight: 700, borderLeft: '1px solid #f0f0f0' }}>{rp(k.realisasi_ytd)}</td>
                              <td style={tdS}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  <div style={{ flex: 1, height: 7, background: '#f0f0f0', borderRadius: 4, minWidth: 80 }}>
                                    <div style={{ height: '100%', width: `${Math.min(pct, 100)}%`, background: pctColor(pct), borderRadius: 4 }} />
                                  </div>
                                  <span style={{ fontSize: 12, fontWeight: 800, color: pctColor(pct), minWidth: 44, textAlign: 'right' }}>
                                    {pct}%
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr style={{ background: '#f0f7ff', borderTop: '2px solid #d6e8ff' }}>
                          <td style={{ ...tdS, textAlign: 'center' }}>—</td>
                          <td style={{ ...tdL, fontWeight: 800, fontSize: 12 }}>TOTAL</td>
                          <td style={{ ...tdS, fontWeight: 700, borderLeft: '1px solid #d6e8ff' }}>{rp(total_pkb_t)}</td>
                          <td style={{ ...tdS, fontWeight: 800, color: '#52c41a' }}>{rp(total_pkb_r)}</td>
                          <td style={{ ...tdS, fontWeight: 700, borderLeft: '1px solid #d6e8ff' }}>{rp(total_bbnkb_t)}</td>
                          <td style={{ ...tdS, fontWeight: 800, color: '#1890ff' }}>{rp(total_bbnkb_r)}</td>
                          <td style={{ ...tdS, fontWeight: 800, color: '#333', borderLeft: '1px solid #d6e8ff' }}>{rp(total_realisasi)}</td>
                          <td style={tdS}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <div style={{ flex: 1, height: 8, background: '#f0f0f0', borderRadius: 4, minWidth: 80 }}>
                                <div style={{ height: '100%', width: `${Math.min(pctAll, 100)}%`, background: pctColor(pctAll), borderRadius: 4 }} />
                              </div>
                              <span style={{ fontSize: 12, fontWeight: 800, color: pctColor(pctAll), minWidth: 44, textAlign: 'right' }}>
                                {pctAll}%
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </Card>
              );
            }

            const BULAN_NAMA2 = ['','Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'];
            const totalRealisasi      = targetRealisasi.bulan.reduce((a, b) => a + (b.realisasi       || 0), 0);
            const totalRealisasiPkb   = targetRealisasi.bulan.reduce((a, b) => a + (b.realisasi_pkb   || 0), 0);
            const totalRealisasiBbnkb = targetRealisasi.bulan.reduce((a, b) => a + (b.realisasi_bbnkb || 0), 0);
            const pctTahunan = targetRealisasi.target_total > 0
              ? Math.round(totalRealisasi / targetRealisasi.target_total * 100) : 0;

            // Jika persen belum diisi (semua 0), gunakan distribusi rata-rata (1/12 tiap bulan)
            const totalPersen  = targetRealisasi.bulan.reduce((s, b) => s + (b.persen_target || 0), 0);
            const useEqualDist = totalPersen === 0 && targetRealisasi.target_total > 0;

            const getMonthTarget = (b) => {
              if (!useEqualDist) return { pkb: b.target_pkb, bbnkb: b.target_bbnkb, total: b.target_total };
              return {
                pkb:   Math.round(targetRealisasi.target_pkb   / 12),
                bbnkb: Math.round(targetRealisasi.target_bbnkb / 12),
                total: Math.round(targetRealisasi.target_total  / 12),
              };
            };

            // ---- Kalkulasi KPI ----
            // Capaian per komponen
            const pctPkb   = targetRealisasi.target_pkb   > 0 ? Math.round(totalRealisasiPkb   / targetRealisasi.target_pkb   * 100) : 0;
            const pctBbnkb = targetRealisasi.target_bbnkb > 0 ? Math.round(totalRealisasiBbnkb / targetRealisasi.target_bbnkb * 100) : 0;
            // Sisa/surplus per komponen
            const sisaPkb   = targetRealisasi.target_pkb   - totalRealisasiPkb;
            const sisaBbnkb = targetRealisasi.target_bbnkb - totalRealisasiBbnkb;
            const sisaTarget      = targetRealisasi.target_total - totalRealisasi;
            const bulanDenganData = targetRealisasi.bulan.filter(b => b.realisasi > 0).length;
            const tahunLaluLabel  = targetRealisasi.tahun_lalu || (targetRealisasi.tahun - 1);

            // Data historis tahun lalu — sekarang berupa array of {total, pkb, bbnkb}
            const emptyLalu     = { total: 0, pkb: 0, bbnkb: 0 };
            const realisasiLalu = (targetRealisasi.realisasi_lalu || []).map(v =>
              (typeof v === 'object' && v !== null) ? v : emptyLalu
            );
            while (realisasiLalu.length < 12) realisasiLalu.push(emptyLalu);

            const adaDataLalu   = realisasiLalu.some(v => v.total > 0);
            // Sisa bulan tahun lalu (bulanSekarang+1 s/d Des)
            const sisaBulanLalu      = realisasiLalu.slice(bulanSekarang).reduce((a, v) => a + v.total, 0);
            const sisaBulanLaluPkb   = realisasiLalu.slice(bulanSekarang).reduce((a, v) => a + v.pkb,   0);
            const sisaBulanLaluBbnkb = realisasiLalu.slice(bulanSekarang).reduce((a, v) => a + v.bbnkb, 0);
            // YTD tahun lalu (Jan s/d bulan ini)
            const ytdLaluSejauh = realisasiLalu.slice(0, bulanSekarang).reduce((a, v) => a + v.total, 0);

            let proyeksiTahunan, proyeksiPkb, proyeksiBbnkb, proyeksiPct, proyeksiMetode;
            if (adaDataLalu && ytdLaluSejauh > 0) {
              // Metode YoY: "YTD tahun ini + sisa bulan tahun lalu" per komponen
              proyeksiTahunan = Math.round(totalRealisasi      + sisaBulanLalu);
              proyeksiPkb     = Math.round(totalRealisasiPkb   + sisaBulanLaluPkb);
              proyeksiBbnkb   = Math.round(totalRealisasiBbnkb + sisaBulanLaluBbnkb);
              proyeksiMetode  = `pola ${tahunLaluLabel}`;
            } else {
              // Fallback: rata-rata sederhana × 12
              const avg       = bulanDenganData > 0 ? totalRealisasi      / bulanDenganData : 0;
              const avgPkb    = bulanDenganData > 0 ? totalRealisasiPkb   / bulanDenganData : 0;
              const avgBbnkb  = bulanDenganData > 0 ? totalRealisasiBbnkb / bulanDenganData : 0;
              proyeksiTahunan = Math.round(avg     * 12);
              proyeksiPkb     = Math.round(avgPkb  * 12);
              proyeksiBbnkb   = Math.round(avgBbnkb * 12);
              proyeksiMetode  = `rata-rata ${bulanDenganData} bln`;
            }
            proyeksiPct     = targetRealisasi.target_total  > 0 ? Math.round(proyeksiTahunan / targetRealisasi.target_total  * 100) : 0;
            const proyeksiPctPkb   = targetRealisasi.target_pkb   > 0 ? Math.round(proyeksiPkb   / targetRealisasi.target_pkb   * 100) : 0;
            const proyeksiPctBbnkb = targetRealisasi.target_bbnkb > 0 ? Math.round(proyeksiBbnkb / targetRealisasi.target_bbnkb * 100) : 0;

            const kpiCard = (label, nilai, sub, warna, borderWarna) => (
              <Col xs={24} sm={12} lg={6}>
                <div style={{
                  borderRadius: 10, padding: '14px 16px', background: '#fff', height: '100%',
                  borderTop: `1px solid ${borderWarna}`, borderRight: `1px solid ${borderWarna}`,
                  borderBottom: `1px solid ${borderWarna}`, borderLeft: `4px solid ${warna}`,
                }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>{label}</div>
                  <div style={{ fontSize: 15, fontWeight: 800, color: warna, lineHeight: 1.3 }}>{nilai}</div>
                  {sub && <div style={{ fontSize: 10, color: '#999', marginTop: 4 }}>{sub}</div>}
                </div>
              </Col>
            );

            return (
              <Card
                style={{ ...cardStyle, marginTop: 12 }}
                bodyStyle={{ padding: 0 }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', padding: '4px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <RiseOutlined style={{ color: '#52c41a', fontSize: 16 }} />
                      <span style={{ fontWeight: 700, fontSize: 13 }}>Target vs Realisasi {targetRealisasi.tahun}</span>
                    </div>
                    {targetRealisasi.kabupaten_nama && (
                      <span style={{ fontSize: 11, color: '#1890ff', fontWeight: 600,
                        background: '#e6f4ff', borderRadius: 10, padding: '1px 8px',
                        border: '1px solid #91caff' }}>
                        {targetRealisasi.kabupaten_nama}
                      </span>
                    )}
                    {useEqualDist && (
                      <span style={{ fontSize: 10, color: '#fa8c16', background: '#fff7e6',
                        border: '1px solid #ffd591', borderRadius: 10, padding: '1px 8px' }}>
                        distribusi rata (alokasi belum diisi)
                      </span>
                    )}
                  </div>
                }
                headStyle={{ minHeight: 48, padding: '0 16px', borderBottom: '1px solid #f0f0f0' }}
              >
                {/* ===== KPI CARDS ===== */}
                <div style={{ padding: '14px 16px 10px', borderBottom: '1px solid #f0f0f0' }}>

                  {/* Label PKB */}
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#52c41a', letterSpacing: 1,
                    marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#52c41a', display: 'inline-block' }} />
                    PKB (Pajak Kendaraan Bermotor)
                  </div>
                  <Row gutter={[10, 10]} style={{ marginBottom: 14 }}>
                    {kpiCard(
                      'Target PKB Tahunan',
                      `Rp ${rp(targetRealisasi.target_pkb)}`,
                      null,
                      '#52c41a', '#b7eb8f'
                    )}
                    {kpiCard(
                      `Realisasi PKB s/d ${BULAN_NAMA2[bulanSekarang]}`,
                      `Rp ${rp(totalRealisasiPkb)}`,
                      <span>Capaian: <strong style={{ color: pctColor(pctPkb) }}>{pctPkb}%</strong></span>,
                      pctColor(pctPkb), '#d9f7be'
                    )}
                    {kpiCard(
                      sisaPkb >= 0 ? 'Sisa Target PKB' : 'Surplus PKB',
                      `${sisaPkb < 0 ? '+' : ''} Rp ${rp(Math.abs(sisaPkb))}`,
                      sisaPkb >= 0
                        ? `Masih perlu Rp ${rp(sisaPkb)} lagi`
                        : `Melampaui target PKB`,
                      sisaPkb >= 0 ? '#fa8c16' : '#52c41a',
                      sisaPkb >= 0 ? '#ffe7ba' : '#d9f7be'
                    )}
                    {kpiCard(
                      'Proyeksi PKB Akhir Tahun',
                      `Rp ${rp(proyeksiPkb)}`,
                      bulanDenganData > 0
                        ? <span>Est. <strong style={{ color: pctColor(proyeksiPctPkb) }}>{proyeksiPctPkb}%</strong>&nbsp;· {proyeksiMetode}</span>
                        : 'Belum ada data',
                      pctColor(proyeksiPctPkb), '#f0f0f0'
                    )}
                  </Row>

                  {/* Label BBNKB */}
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#1890ff', letterSpacing: 1,
                    marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#1890ff', display: 'inline-block' }} />
                    BBNKB (Bea Balik Nama Kendaraan Bermotor)
                  </div>
                  <Row gutter={[10, 10]}>
                    {kpiCard(
                      'Target BBNKB Tahunan',
                      `Rp ${rp(targetRealisasi.target_bbnkb)}`,
                      null,
                      '#1890ff', '#bae0ff'
                    )}
                    {kpiCard(
                      `Realisasi BBNKB s/d ${BULAN_NAMA2[bulanSekarang]}`,
                      `Rp ${rp(totalRealisasiBbnkb)}`,
                      <span>Capaian: <strong style={{ color: pctColor(pctBbnkb) }}>{pctBbnkb}%</strong></span>,
                      pctColor(pctBbnkb), '#bae0ff'
                    )}
                    {kpiCard(
                      sisaBbnkb >= 0 ? 'Sisa Target BBNKB' : 'Surplus BBNKB',
                      `${sisaBbnkb < 0 ? '+' : ''} Rp ${rp(Math.abs(sisaBbnkb))}`,
                      sisaBbnkb >= 0
                        ? `Masih perlu Rp ${rp(sisaBbnkb)} lagi`
                        : `Melampaui target BBNKB`,
                      sisaBbnkb >= 0 ? '#fa8c16' : '#1890ff',
                      sisaBbnkb >= 0 ? '#ffe7ba' : '#bae0ff'
                    )}
                    {kpiCard(
                      'Proyeksi BBNKB Akhir Tahun',
                      `Rp ${rp(proyeksiBbnkb)}`,
                      bulanDenganData > 0
                        ? <span>Est. <strong style={{ color: pctColor(proyeksiPctBbnkb) }}>{proyeksiPctBbnkb}%</strong>&nbsp;· {proyeksiMetode}</span>
                        : 'Belum ada data',
                      pctColor(proyeksiPctBbnkb), '#f0f0f0'
                    )}
                  </Row>
                </div>

                {/* ===== TABEL PER BULAN ===== */}
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ ...thL, verticalAlign: 'middle' }} rowSpan={2}>Bulan</th>
                        <th style={{ ...thS, textAlign: 'center', borderBottom: '1px solid #e8e8e8' }} colSpan={2}>PKB</th>
                        <th style={{ ...thS, textAlign: 'center', borderBottom: '1px solid #e8e8e8', borderLeft: '1px solid #e8e8e8' }} colSpan={2}>BBNKB</th>
                        <th style={{ ...thS, verticalAlign: 'middle', borderLeft: '1px solid #e8e8e8' }} rowSpan={2}>Total Realisasi</th>
                        <th style={{ ...thS, color: '#888', verticalAlign: 'middle' }} rowSpan={2}>{tahunLaluLabel}</th>
                        <th style={{ ...thS, verticalAlign: 'middle' }} rowSpan={2}>Selisih</th>
                        <th style={{ ...thS, minWidth: 140, verticalAlign: 'middle' }} rowSpan={2}>Capaian</th>
                      </tr>
                      <tr>
                        <th style={thS}>Target</th>
                        <th style={thS}>Realisasi</th>
                        <th style={{ ...thS, borderLeft: '1px solid #e8e8e8' }}>Target</th>
                        <th style={thS}>Realisasi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {targetRealisasi.bulan.map(b => {
                        const isBulanIni    = b.bulan === bulanSekarang;
                        const isFuture      = b.bulan > bulanSekarang;
                        const mt            = getMonthTarget(b);
                        const realPkb       = b.realisasi_pkb   || 0;
                        const realBbnkb     = b.realisasi_bbnkb || 0;
                        const pct           = mt.total > 0 ? Math.round(b.realisasi / mt.total * 100) : 0;
                        const selisih       = b.realisasi - mt.total;
                        const selisihColor  = selisih >= 0 ? '#52c41a' : '#f5222d';
                        const lalu          = realisasiLalu[b.bulan - 1] || emptyLalu;
                        const yoyDiff       = !isFuture && lalu.total > 0
                          ? Math.round((b.realisasi - lalu.total) / lalu.total * 100) : null;
                        const dim = { color: '#ccc' };
                        return (
                          <tr key={b.bulan} style={{ background: isBulanIni ? '#fffbe6' : isFuture ? '#fafafa' : '' }}>
                            <td style={{ ...tdL, fontWeight: isBulanIni ? 800 : 600, color: isBulanIni ? '#fa8c16' : isFuture ? '#bbb' : undefined }}>
                              {BULAN_NAMA2[b.bulan]}
                              {isBulanIni && <span style={{ marginLeft: 4, fontSize: 9, color: '#fa8c16', fontWeight: 700 }}>▶ ini</span>}
                            </td>
                            {/* PKB */}
                            <td style={{ ...tdS, ...(isFuture ? dim : {}) }}>{rp(mt.pkb)}</td>
                            <td style={{ ...tdS, color: isFuture ? '#ccc' : '#52c41a', fontWeight: isFuture ? 400 : 600 }}>
                              {isFuture ? '—' : rp(realPkb)}
                            </td>
                            {/* BBNKB */}
                            <td style={{ ...tdS, ...(isFuture ? dim : {}), borderLeft: '1px solid #f0f0f0' }}>{rp(mt.bbnkb)}</td>
                            <td style={{ ...tdS, color: isFuture ? '#ccc' : '#1890ff', fontWeight: isFuture ? 400 : 600 }}>
                              {isFuture ? '—' : rp(realBbnkb)}
                            </td>
                            {/* Total */}
                            <td style={{ ...tdS, fontWeight: 700, color: isFuture ? '#ccc' : '#333', borderLeft: '1px solid #f0f0f0' }}>
                              {isFuture ? '—' : rp(b.realisasi)}
                            </td>
                            {/* Thn Lalu */}
                            <td style={{ ...tdS, color: '#bbb', fontStyle: 'italic' }}>
                              {lalu.total > 0 ? (
                                <span>
                                  {rp(lalu.total)}
                                  {yoyDiff !== null && (
                                    <span style={{ marginLeft: 4, fontSize: 9, color: yoyDiff >= 0 ? '#52c41a' : '#f5222d' }}>
                                      {yoyDiff >= 0 ? '▲' : '▼'}{Math.abs(yoyDiff)}%
                                    </span>
                                  )}
                                </span>
                              ) : <span style={{ color: '#ddd' }}>—</span>}
                            </td>
                            {/* Selisih */}
                            <td style={{ ...tdS, fontWeight: 700, color: isFuture ? '#ccc' : selisihColor }}>
                              {isFuture ? '—' : `${selisih >= 0 ? '+' : ''}${rp(selisih)}`}
                            </td>
                            {/* Capaian */}
                            <td style={tdS}>
                              {!isFuture && mt.total > 0 ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  <div style={{ flex: 1, height: 6, background: '#f0f0f0', borderRadius: 3, minWidth: 70 }}>
                                    <div style={{ height: '100%', width: `${Math.min(pct, 100)}%`, background: pctColor(pct), borderRadius: 3 }} />
                                  </div>
                                  <span style={{ fontSize: 11, fontWeight: 700, color: pctColor(pct), minWidth: 36, textAlign: 'right' }}>
                                    {pct}%
                                  </span>
                                </div>
                              ) : <span style={{ color: '#ccc' }}>—</span>}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr style={{ background: '#f0f7ff', borderTop: '2px solid #d6e8ff' }}>
                        <td style={{ ...tdL, fontWeight: 800, fontSize: 12 }}>TOTAL</td>
                        {/* PKB */}
                        <td style={{ ...tdS, fontWeight: 700 }}>{rp(targetRealisasi.target_pkb)}</td>
                        <td style={{ ...tdS, fontWeight: 800, color: '#52c41a' }}>{rp(totalRealisasiPkb)}</td>
                        {/* BBNKB */}
                        <td style={{ ...tdS, fontWeight: 700, borderLeft: '1px solid #d6e8ff' }}>{rp(targetRealisasi.target_bbnkb)}</td>
                        <td style={{ ...tdS, fontWeight: 800, color: '#1890ff' }}>{rp(totalRealisasiBbnkb)}</td>
                        {/* Total */}
                        <td style={{ ...tdS, fontWeight: 800, color: '#333', borderLeft: '1px solid #d6e8ff' }}>{rp(totalRealisasi)}</td>
                        {/* Thn Lalu */}
                        <td style={{ ...tdS, color: '#bbb', fontStyle: 'italic' }}>
                          {rp(realisasiLalu.reduce((a, v) => a + v.total, 0))}
                        </td>
                        <td style={{ ...tdS, fontWeight: 800, color: sisaTarget >= 0 ? '#f5222d' : '#52c41a' }}>
                          {sisaTarget >= 0 ? '' : '+'}{rp(Math.abs(sisaTarget))}
                          <div style={{ fontSize: 9, fontWeight: 400, color: '#aaa' }}>
                            {sisaTarget >= 0 ? 'sisa' : 'surplus'}
                          </div>
                        </td>
                        <td style={tdS}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div style={{ flex: 1, height: 8, background: '#f0f0f0', borderRadius: 4, minWidth: 70 }}>
                              <div style={{ height: '100%', width: `${Math.min(pctTahunan, 100)}%`,
                                background: pctColor(pctTahunan), borderRadius: 4 }} />
                            </div>
                            <span style={{ fontSize: 12, fontWeight: 800, color: pctColor(pctTahunan), minWidth: 36, textAlign: 'right' }}>
                              {pctTahunan}%
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </Card>
            );
          })()}

          {/* ===== KENDARAAN JATUH TEMPO + RATA-RATA WAKTU PROSES ===== */}
          <Row gutter={[12, 12]} style={{ marginTop: 12 }}>
            {/* Kendaraan Jatuh Tempo */}
            {[{label: '7 Hari', val: kendaraanJatuhTempo.h7, color: '#f5222d', bg: '#fff1f0'},
              {label: '14 Hari', val: kendaraanJatuhTempo.h14, color: '#fa8c16', bg: '#fff7e6'},
              {label: '30 Hari', val: kendaraanJatuhTempo.h30, color: '#faad14', bg: '#fffbe6'},
            ].map(k => (
              <Col key={k.label} xs={12} sm={8} lg={4}>
                <Card style={cardStyle} bodyStyle={{ padding: '14px 16px' }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>
                    <CalendarOutlined /> Jatuh Tempo {k.label}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 8, background: k.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CarOutlined style={{ color: k.color, fontSize: 18 }} />
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: k.color, lineHeight: 1 }}>
                      {(k.val || 0).toLocaleString('id-ID')}
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
            {/* Rata-rata Waktu Proses */}
            {[{label: 'Daftar → Tetap', val: rataRataWaktu.daftar_ke_penetapan, icon: <FieldTimeOutlined />, color: '#1890ff'},
              {label: 'Tetap → Bayar', val: rataRataWaktu.penetapan_ke_pembayaran, icon: <ClockCircleOutlined />, color: '#fa8c16'},
              {label: 'Total Proses', val: rataRataWaktu.total, icon: <ThunderboltOutlined />, color: '#52c41a'},
            ].map(k => (
              <Col key={k.label} xs={12} sm={8} lg={4}>
                <Card style={cardStyle} bodyStyle={{ padding: '14px 16px' }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>{k.icon} {k.label}</div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: k.color, lineHeight: 1 }}>
                    {k.val} <span style={{ fontSize: 12, fontWeight: 400 }}>menit</span>
                  </div>
                  {k.label === 'Total Proses' && (
                    <div style={{ fontSize: 10, color: '#bbb', marginTop: 2 }}>{rataRataWaktu.jumlah_sampel} sampel hari ini</div>
                  )}
                </Card>
              </Col>
            ))}
          </Row>

          <Divider style={{ margin: '16px 0' }} />

          {/* ===== PENERIMAAN HARIAN REALTIME ===== */}
          <RealtimePenerimaan
            uptDipilih={this.props.uptDipilih}
            uptParam={uptParam}
            kabupatenParam={kabupatenParam}
            onNewTransaction={this._onNewTransactionHari}
          />

          <Divider style={{ margin: '16px 0' }} />

          {/* === Grafik === */}
          <Row gutter={[12, 12]}>
            <Col xs={24} lg={12}>
              <Card
                title={`Pembayaran per Hari — ${tahunLalu} vs ${tahun} (30 Hari Terakhir)`}
                style={cardStyle}
                bodyStyle={{ padding: '12px 16px' }}
              >
                <Line data={grafikHarian} options={lineOptions} />
              </Card>
            </Col>
            <Col xs={24} lg={12}>
              <Card
                title={
                  <span>
                    Pembayaran per Bulan — {tahunLalu} vs {tahun}
                    <span style={{
                      marginLeft: 8, fontSize: 11, fontWeight: 400,
                      color: '#fa8c16', background: '#fff7e6',
                      border: '1px solid #ffd591', borderRadius: 10,
                      padding: '1px 8px',
                    }}>
                      + Kumulatif
                    </span>
                  </span>
                }
                style={cardStyle}
                bodyStyle={{ padding: '12px 16px' }}
              >
                <Bar data={grafikBulanan} options={comboOptions} />
              </Card>
            </Col>
          </Row>

          {/* === Grafik Pembayaran per UPT (cakupan 1 & 2, bulan ini) === */}
          {showPerUpt && (
            <>
              <Divider style={{ margin: '16px 0 12px' }} />
              <Card
                style={{ ...cardStyle, marginBottom: 12 }}
                bodyStyle={{ padding: '12px 16px' }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <ApartmentOutlined style={{ color: WARNA.ungu, fontSize: 16 }} />
                    <span style={{ fontWeight: 700 }}>Pembayaran per UPT — Bulan Ini</span>
                    <Tag style={{ borderRadius: 20, fontSize: 11, marginLeft: 4 }}>
                      Klik UPT untuk drill-down
                    </Tag>
                  </div>
                }
              >
                <div style={{ height: Math.max(200, (grafikPerUpt.labels || []).length * 34) }}>
                  <HorizontalBar
                    data={grafikPerUpt}
                    options={{
                      ...perUptOptions,
                      onClick: (_, elements) => {
                        if (!elements || !elements.length) return;
                        const idx = elements[0]._index;
                        const perUptRaw = (this.props.responseMsg && this.props.responseMsg.grafik_per_upt) || [];
                        const row = perUptRaw[idx];
                        if (row && row.upt_id) {
                          this.setState({ uptParam: row.upt_id });
                          this.getData(kabupatenParam, row.upt_id);
                        }
                      },
                    }}
                  />
                </div>
              </Card>
            </>
          )}

          {/* ===== GRAFIK JAM SIBUK + DISTRIBUSI JENIS KENDARAAN + DISTRIBUSI LAYANAN ===== */}
          <Divider style={{ margin: '16px 0 12px' }} />
          <Row gutter={[12, 12]}>
            {/* Grafik Jam Sibuk */}
            <Col xs={24} lg={8}>
              <Card
                style={cardStyle}
                bodyStyle={{ padding: '12px 16px' }}
                title={<span><ClockCircleOutlined style={{ color: '#fa8c16' }} /> Jam Sibuk — Hari Ini</span>}
              >
                {grafikJam.length > 0 ? (
                  <Bar
                    data={{
                      labels: grafikJam.map(d => `${String(d.jam).padStart(2, '0')}:00`),
                      datasets: [{
                        label: 'Pembayaran',
                        data: grafikJam.map(d => d.jumlah),
                        backgroundColor: grafikJam.map(d => {
                          const maxJam = Math.max(...grafikJam.map(j => j.jumlah));
                          return d.jumlah === maxJam && d.jumlah > 0 ? '#f5222d' : 'rgba(24,144,255,0.65)';
                        }),
                        borderRadius: 4,
                      }],
                    }}
                    options={{
                      responsive: true,
                      maintainAspectRatio: true,
                      legend: { display: false },
                      scales: {
                        yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
                        xAxes: [{ ticks: { fontSize: 10 } }],
                      },
                      tooltips: {
                        callbacks: {
                          label: item => `${Number(item.yLabel).toLocaleString('id-ID')} transaksi`,
                        },
                      },
                    }}
                  />
                ) : <Empty description="Belum ada data" />}
              </Card>
            </Col>
            {/* Top 5 Jenis Kendaraan */}
            <Col xs={24} lg={8}>
              <Card
                style={cardStyle}
                bodyStyle={{ padding: '12px 16px' }}
                title={<span><CarOutlined style={{ color: '#722ed1' }} /> Top Jenis Kendaraan — Bulan Ini</span>}
              >
                {distribusiJenisKendaraan.length > 0 ? (
                  <HorizontalBar
                    data={{
                      labels: distribusiJenisKendaraan.map(d => d.nama),
                      datasets: [{
                        label: 'Pembayaran',
                        data: distribusiJenisKendaraan.map(d => d.jumlah),
                        backgroundColor: ['#722ed1cc', '#1890ffcc', '#52c41acc', '#fa8c16cc', '#13c2c2cc'],
                        borderWidth: 0,
                        borderRadius: 4,
                      }],
                    }}
                    options={{
                      responsive: true,
                      maintainAspectRatio: true,
                      legend: { display: false },
                      scales: {
                        xAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
                        yAxes: [{ ticks: { fontSize: 11 } }],
                      },
                      tooltips: {
                        callbacks: {
                          label: item => `${Number(item.xLabel).toLocaleString('id-ID')} kendaraan`,
                        },
                      },
                    }}
                  />
                ) : <Empty description="Belum ada data" />}
              </Card>
            </Col>
            {/* Distribusi Layanan */}
            <Col xs={24} lg={8}>
              <Card
                style={cardStyle}
                bodyStyle={{ padding: '12px 16px' }}
                title={<span><FileAddOutlined style={{ color: '#1890ff' }} /> Distribusi Layanan — Bulan Ini</span>}
              >
                {distribusiLayanan.length > 0 ? (
                  <div>
                    {distribusiLayanan.map((l, i) => {
                      const maxVal = distribusiLayanan[0]?.jumlah || 1;
                      const pct = Math.round((l.jumlah / maxVal) * 100);
                      const colors = ['#1890ff', '#52c41a', '#fa8c16', '#722ed1', '#13c2c2', '#eb2f96', '#faad14', '#2f54eb', '#a0d911', '#f5222d'];
                      const clr = colors[i % colors.length];
                      return (
                        <div key={l.kode} style={{ marginBottom: 8 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginBottom: 2 }}>
                            <span style={{ color: '#555', fontWeight: 600 }}>{l.nama}</span>
                            <span style={{ color: clr, fontWeight: 700 }}>{l.jumlah.toLocaleString('id-ID')}</span>
                          </div>
                          <div style={{ height: 6, background: '#f0f0f0', borderRadius: 3 }}>
                            <div style={{ height: '100%', width: `${pct}%`, background: clr, borderRadius: 3, transition: 'width 0.5s' }} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : <Empty description="Belum ada data" />}
              </Card>
            </Col>
          </Row>

          {/* ===== RANKING UPT (cakupan 1 & 2) ===== */}
          {rankingUpt.length > 0 && (
            <>
              <Divider style={{ margin: '16px 0 12px' }} />
              <Card
                style={{ ...cardStyle, marginBottom: 12 }}
                bodyStyle={{ padding: 0 }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <TrophyOutlined style={{ color: '#faad14', fontSize: 16 }} />
                    <span style={{ fontWeight: 700 }}>Ranking UPT — Bulan Ini</span>
                  </div>
                }
              >
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#fafafa' }}>
                        <th style={{ padding: '8px 12px', fontSize: 11, fontWeight: 700, color: '#555', textAlign: 'center', borderBottom: '1px solid #e8e8e8', width: 40 }}>No</th>
                        <th style={{ padding: '8px 12px', fontSize: 11, fontWeight: 700, color: '#555', textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>UPT</th>
                        <th style={{ padding: '8px 12px', fontSize: 11, fontWeight: 700, color: '#555', textAlign: 'right', borderBottom: '1px solid #e8e8e8' }}>Pembayaran</th>
                        <th style={{ padding: '8px 12px', fontSize: 11, fontWeight: 700, color: '#555', textAlign: 'right', borderBottom: '1px solid #e8e8e8' }}>Pendapatan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rankingUpt.map((r, i) => (
                        <tr key={r.upt_id} style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f0f7ff'}
                          onMouseLeave={e => e.currentTarget.style.background = ''}
                          onClick={() => {
                            this.setState({ uptParam: r.upt_id });
                            this.getData(kabupatenParam, r.upt_id);
                          }}
                        >
                          <td style={{ padding: '7px 12px', fontSize: 12, textAlign: 'center', borderBottom: '1px solid #f0f0f0' }}>
                            {i < 3
                              ? <span style={{ display: 'inline-flex', width: 22, height: 22, borderRadius: '50%', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 11, color: '#fff', background: i === 0 ? '#faad14' : i === 1 ? '#bfbfbf' : '#d48806' }}>{i + 1}</span>
                              : <span style={{ color: '#aaa' }}>{i + 1}</span>
                            }
                          </td>
                          <td style={{ padding: '7px 12px', fontSize: 12, fontWeight: 600, borderBottom: '1px solid #f0f0f0' }}>{r.upt}</td>
                          <td style={{ padding: '7px 12px', fontSize: 12, textAlign: 'right', borderBottom: '1px solid #f0f0f0' }}>{r.pembayaran.toLocaleString('id-ID')}</td>
                          <td style={{ padding: '7px 12px', fontSize: 12, textAlign: 'right', fontWeight: 700, color: '#1890ff', borderBottom: '1px solid #f0f0f0' }}>Rp {r.pendapatan.toLocaleString('id-ID')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card>
            </>
          )}

        </Spin>

        {/* Drawer & Modal Pengumuman/User Aktif dipindah ke AdminLayout */}

        {(() => {
          const kartuAktif = kartuHariIni.find(k => k.statusKey === detailModalStatus);
          const canHapus = this.props.isSuperadmin || levelUser <= 2 || !!(this.props.akses && this.props.akses.transaksi_hapus_dashboard);
          return (
            <DashboardDetailModal
              visible={!!detailModalStatus}
              onClose={() => this.setState({ detailModalStatus: null })}
              statusKey={detailModalStatus}
              label={kartuAktif ? kartuAktif.label : ''}
              icon={kartuAktif ? kartuAktif.icon : null}
              warna={kartuAktif ? kartuAktif.warna : undefined}
              kabupatenParam={kabupatenParam}
              uptParam={uptParam}
              canHapus={canHapus}
              onDeleted={() => this.getData(kabupatenParam, uptParam)}
            />
          );
        })()}
      </div>
    );
  }
}

const mapStateToProps = state => state.configReducers;

export default connect(
  mapStateToProps,
  { initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(Home);
